var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.types=='orders')?_c('orders',{attrs:{"filters":_vm.filters}}):_vm._e(),(_vm.types=='sales')?_c('sales',{attrs:{"filters":_vm.filters}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }